import { ProgressBarItemMultiModified } from 'components/ProgressBar/context';
import { Check } from 'lucide-react';

import ProgressBarItemMultiSubstep from './ProgressBarItemMultiSubstep';
import useProgressBarItemMulti from './useProgressBarItemMulti';

const ProgressBarItemMulti: React.FunctionComponent<
  Omit<ProgressBarItemMultiModified, 'type'>
> = function (props) {
  const {
    showHeader,
    title,
    trackClassName,
    stepLabel,
    labelClassName,
    active,
    substeps,
    last,
  } = useProgressBarItemMulti(props);
  return (
    <div className="flex flex-col w-full">
      {showHeader && <div className="h-[6px] min-h-[6px] w-8 bg-neutral-300" />}
      <div className="flex flex-row gap-x-4">
        <div className="flex flex-col">
          <div className={trackClassName}>
            <div className={labelClassName}>
              {stepLabel ? (
                <p className="m-auto">{stepLabel}</p>
              ) : (
                <Check size={20} className="m-auto" strokeWidth={2} />
              )}
            </div>
          </div>
          <div className="flex-[1_1_0] bg-neutral-300" />
        </div>
        <div className="py-1">
          <p className="text-16-24-em text-neutral-900">{title}</p>
        </div>
      </div>
      <div className="h-[6px] min-h-[6px] w-8 bg-neutral-300" />
      {active &&
        substeps.map(({ key, ...rest }) => (
          <ProgressBarItemMultiSubstep
            key={key}
            finalMainStep={last}
            {...rest}
          />
        ))}
    </div>
  );
};

export default ProgressBarItemMulti;
